import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

interface ProtectedRouteProps {
  permissionSelector: (state: any) => boolean; // Adjust the `any` type to match your Redux state type
  children?: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ permissionSelector, children }) => {
  const hasPermission = useSelector(permissionSelector);

  if (!hasPermission) {
    // Redirect to the Unauthorized page if permission is denied
    return <Navigate to="/dashboard" />;
  }

  // Render the protected content if permission is granted
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
